import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Emerging Technologies in UI/UX Design',
                topics: [
                    'The impact of Augmented Reality (AR) and Virtual Reality (VR) on UI/UX design',
                    'Integrating voice interfaces into UI/UX design',
                    'The role of AI in UI/UX design: exploring automation and machine learning',
                    'The impact of blockchain technology on UI/UX design',
                    'The impact of 5G technology on UI/UX design',
                ],
            },
            {
                title: 'User-Centered Design',
                topics: [
                    'Designing for accessibility: creating inclusive UI/UX experiences for users with disabilities',
                    'Personalization in UI/UX: creating user-centered experiences',
                    'The importance of micro-interactions in UI/UX design',
                    'The psychology of color in UI/UX design',
                    'Designing for emotional experiences: exploring the role of empathy in UI/UX',
                ],
            },
            {
                title: 'Designing for Specific Contexts',
                topics: [
                    'Designing for mobile-first: strategies for creating effective mobile UI/UX',
                    'The impact of social media on UI/UX design trends',
                    'Designing for multi-device experiences: creating seamless transitions across different platforms',
                    'The role of UI/UX in e-commerce: creating effective user experiences for online shopping',
                    'The impact of cultural diversity on UI/UX design: designing for global audiences',
                ],
            },
            {
                title: 'Ethical Considerations in UI/UX Design',
                topics: [
                    'The ethics of UI/UX design: creating responsible and ethical user experiences',
                    'The role of UI/UX in gamification: designing engaging and immersive experiences',
                    'Designing for the Internet of Things (IoT): creating user-friendly experiences for smart devices',
                    'The role of UI/UX in cybersecurity: creating secure and trustworthy user experiences',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;